var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.70831 11.5007H16.2916M11.5 6.70898V16.2923V6.70898Z",
    stroke: "white",
    strokeWidth: 1.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 21.0827C16.7928 21.0827 21.0834 16.7921 21.0834 11.4993C21.0834 6.20662 16.7928 1.91602 11.5 1.91602C6.20729 1.91602 1.91669 6.20662 1.91669 11.4993C1.91669 16.7921 6.20729 21.0827 11.5 21.0827Z",
    stroke: "white",
    strokeWidth: 1.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plusCircle.57b56a411677f03e1c4435b6395f4394.svg";
export { ForwardRef as ReactComponent };